// Base URL of the backend API.
//
// In production the frontend and the backend share the host
// (report-politogroupsbot.appuntipolito.it): the in-cluster traefik routes
// /api/* to the backend, so a relative path is enough. During local
// development (`npm run dev` on localhost) the backend is expected on port
// 8080. Either can be overridden by defining window.__API_BASE_URL__ before the
// bundle is loaded (e.g. in public/index.html).
const LOCAL_HOSTS = ['localhost', '127.0.0.1'];

export const API_BASE_URL =
  window.__API_BASE_URL__ ||
  (LOCAL_HOSTS.includes(window.location.hostname) ? 'http://localhost:8080/api/v1' : '/api/v1');
